/* eslint-disable @typescript-eslint/no-unused-vars */
import { AutocompleteWithLabel, IOSSwitch } from '@adotel/components'
import {
  LazyQueryExecFunction,
  OperationVariables,
  useLazyQuery,
  useQuery
} from '@apollo/client'
import { Button, Divider, Grow, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import { ACCOMMODATIONS_QUERY } from '../../../graphql/accommodation'
import { ROOMTYPES_QUERY } from '../../../graphql/roomtype'
import { TENANTS_QUERY } from '../../../graphql/tenant'
import { DateObject } from '../../../helpers/date'
import {
  getDefaultCurrency,
  getRoleFromStorage
} from '../../../helpers/userData'
import { getTranslate, lang } from '../../../localization'
import inventoryPagesRoleManagement from '../../../staticRoleManagement/inventoryRoleManagement'
import { Accommodation } from '../../../types/accommodation'
import { CRSInventoryData, GetInventoryInput } from '../../../types/inventory'
import { RoomType } from '../../../types/roomtype'
import { Tenant } from '../../../types/tenants'
import useStyles from './styles/PrimaryFilterModal.styles'

interface PrimaryFilterModalProps {
  getInventoryInput: GetInventoryInput
  setgetInventoryInput: React.Dispatch<React.SetStateAction<GetInventoryInput>>
  getCRSInventory: LazyQueryExecFunction<
    {
      crsInventory: CRSInventoryData
    },
    OperationVariables
  >
  setFilterButtonSelected: React.Dispatch<React.SetStateAction<boolean>>
  autoCompleteLabelAccommodation: any
  setautoCompleteLabelAccommodation: React.Dispatch<any>
  shownTable: 'roomtypes' | 'providers' | 'rateplans'
  setshownTable: React.Dispatch<
    React.SetStateAction<'roomtypes' | 'providers' | 'rateplans'>
  >
  accommodations: Accommodation[]
  loadingForAccommodationList: boolean
  selectedDateInDatePicker: DateObject
  setselectedDateInDatePicker: React.Dispatch<React.SetStateAction<DateObject>>
  isRoleChannel: boolean | undefined
  isRoleProvider: boolean | undefined
}

const PrimaryFilterModal = ({
  getInventoryInput,
  setgetInventoryInput,
  getCRSInventory,
  accommodations,
  loadingForAccommodationList,
  setFilterButtonSelected,
  autoCompleteLabelAccommodation,
  setautoCompleteLabelAccommodation,
  selectedDateInDatePicker,
  setselectedDateInDatePicker,
  isRoleChannel,
  isRoleProvider
}: PrimaryFilterModalProps) => {
  const classes = useStyles()

  return (
    <Grow in>
      <div className={classes.root}>
        <div className={classes.selectBoxes}>
          <div className={classes.oneBoxInRow}>
            <div className={classes.fullWidth}>
              <div className={classes.ButtonsContainerForPrimaryFilter}>
                <Typography
                  className={classes.typographyOfTitleForPrimaryFilter}
                  variant="h1">
                  {getTranslate('Filter')}
                </Typography>
              </div>
              <AutocompleteWithLabel
                label={getTranslate('Accommodation')}
                placeholder={getTranslate('Select accommodation')}
                includeInputInList
                onChange={(event, v: any) => {
                  if (v) {
                    setautoCompleteLabelAccommodation({
                      value: v.value,
                      label: v.label,
                      code: v.code
                    })
                    setgetInventoryInput({
                      ...getInventoryInput,
                      propertyCode: v.code,
                      channelID: isRoleChannel
                        ? getInventoryInput.channelID
                        : '',
                      Currency: getDefaultCurrency(),
                      providerCode: isRoleProvider
                        ? getInventoryInput.providerCode
                        : '',
                      ratePlanCode: '',
                      roomTypeCode: ''
                    })
                  } else {
                    setautoCompleteLabelAccommodation(null)
                    setgetInventoryInput({
                      ...getInventoryInput,
                      propertyCode: '',
                      channelID: isRoleChannel
                        ? getInventoryInput.channelID
                        : '',
                      Currency: getDefaultCurrency(),
                      providerCode: isRoleProvider
                        ? getInventoryInput.providerCode
                        : '',
                      ratePlanCode: '',
                      roomTypeCode: ''
                    })
                  }
                }}
                fullWidth
                getOptionSelected={(option, value) =>
                  option.value === value.value && option.label === value.label
                }
                getOptionLabel={(option) => option.label || ''}
                options={
                  accommodations?.map((item) => ({
                    label: item.basicDetails.name,
                    value: item.basicDetails.accommodationID || '',
                    code: item.basicDetails.propertyCode
                  })) || []
                }
                value={autoCompleteLabelAccommodation}
                renderOption={(option) => <>{option.label}</>}
                size="small"
                inputSize="small"
                loading={loadingForAccommodationList}
                loadingText={getTranslate('Loading') + '...'}
              />
              {/* <div className={classes.switchContainer}>
                <Typography variant="body1">
                  {getTranslate(
                    'Turn On the switch button if you want to see price and other restrictions'
                  )}
                </Typography>
                <IOSSwitch
                  color="primary"
                  checked={shownTable === 'providers'}
                  onChange={(e) => {
                    setshownTable(e.target.checked ? 'providers' : 'roomtypes')
                  }}
                />
              </div>
              <AutocompleteWithLabel
                label={getTranslate('Room Type')}
                placeholder={getTranslate('Select Room type')}
                includeInputInList
                onChange={(_, v: any) => {
                  if (v) {
                    setautoCompleteLabelRoomType({
                      value: v.value,
                      label: v.label,
                      code: v.code
                    })
                  } else {
                    setautoCompleteLabelRoomType({
                      value: '',
                      label: '',
                      code: ''
                    })
                  }
                }}
                getOptionSelected={(option, value) =>
                  option.value === value.value && option.label === value.label
                }
                getOptionLabel={(option) => option.label || ''}
                value={autoCompleteLabelRoomType}
                options={
                  roomTypes?.map((roomtype) => ({
                    label: roomtype.name,
                    value: roomtype.id || '',
                    code: roomtype.code
                  })) || []
                }
                renderOption={(option) => <>{option.label}</>}
                size="small"
                fullWidth
                inputSize="small"
                disabled={shownTable !== 'rateplans'}
                loading={loadingForRoomtypes}
                loadingText={getTranslate('Please wait...')}
              /> */}
            </div>
            <div className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={!!!autoCompleteLabelAccommodation.value}
                onClick={() => {
                  getCRSInventory({
                    variables: {
                      input: {
                        propertyCode: autoCompleteLabelAccommodation.code,
                        startDate: selectedDateInDatePicker.gregorianStartDate,
                        endDate: selectedDateInDatePicker.gregorianEndDate,
                        roomTypeCode: '',
                        ratePlanCode: '',
                        Currency: 'IRR',
                        channelID: '',
                        providerCode: ''
                      }
                    }
                  })
                  setFilterButtonSelected(false)
                }}>
                {getTranslate('Search')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Grow>
  )
}

export default PrimaryFilterModal
